
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { OverlayContentComponent } from '@acaprojects/ngx-widgets';
import { UploadManager, Upload } from '@acaprojects/ngx-uploads';

import { AppService } from '../../../../services/app.service';
import { ICateringMenuCategory } from '../../../../services/data/models/interfaces';

import * as blobUtil from 'blob-util';

@Component({
    selector: 'catering-category-modal',
    templateUrl: './category-modal.component.html',
    styleUrls: ['./category-modal.component.scss']
})
export class CateringCategoryModalComponent extends OverlayContentComponent<AppService> {

    public model: { [name: string]: any } = {};
    /** Form data for catering category */
    public form: { [name: string]: any } = {};
    /** Whether a request is being processed */
    public loading: boolean;
    /** Whether a image upload request is being processed */
    public loading_image: boolean;
    /** Whether the last request was successful */
    public success: boolean;
    /** Whether the category is being deleted */
    public deleting: boolean;

    constructor(private _upload_manager: UploadManager, protected _cdr: ChangeDetectorRef) {
        super(_cdr);
    }

    /** Category to edit */
    public get category(): ICateringMenuCategory {
        return this.model.category;
    }

    /** Whether the form fields are valid */
    public get valid(): boolean {
        return !!this.form.name;
    }

    public init(): void {
        if (this.category) {
            this.form = { ...this.category };
        }
    }

    /**
     * Save new category or changes to the existing category
     */
    public save() {
        const bld = this.service.Buildings.current();
        if (this.service && bld) {
            this.form.zones = [bld.id];
            this.loading = true;
            const request = this.form.id
                ? this.service.CateringCategories.updateItem(this.form.id, this.form)
                : this.service.CateringCategories.add(this.form)
            request.then(() => {
                this.success = true;
                this.timeout('close', () => this.event('finish'), 3000);
            }, () => {
                this.loading = false;
                this.service.error(`Failed to ${this.category ? 'update' : 'create'} category`);
            })
        }
    }

    /**
     * Delete the category set on the modal
     */
    public delete() {
        if (this.category.id) {
            this.deleting = true;
            this.loading = true;
            this.service.CateringCategories.delete(this.category.id).then(() => {
                this.success = true;
                this.service.success('Succesfully deleted category');
                this.timeout('close', () => this.event('finish'), 3000);
            }, () => {
                this.deleting = false;
                this.loading = false;
                this.service.error('Failed to delete category');
            });
        }
    }

    /** Upload the image to the cloud */
    public uploadImage(event) {
        if (event && event.target && event.target.files) {
            const files: FileList = event.target.files;
            if (files.length) {
                const fileReader = new FileReader();
                fileReader.onloadend = (e: any) => {
                    this.loading_image = true;
                    const arrayBuffer = e.target.result;
                    const blob = blobUtil.arrayBufferToBlob(arrayBuffer, 'image/png');
                    this._upload_manager.upload([blob], { file_name: files[0].name });
                    const upload = this._upload_manager.uploads[this._upload_manager.uploads.length - 1];
                    this.interval('upload', () => {
                        if (upload.complete || upload.error) {
                            if (upload.access_url && upload.complete) {
                                this.form.src = upload.access_url;
                            }
                            this.loading_image = false;
                            this.clearInterval('upload');
                        }
                    })
                };
                fileReader.readAsArrayBuffer(files[0]);
            }
        }
    }
}

